import React, { useEffect, useState } from 'react';
import { Container } from '../ui/Container';
import { conceptsContent } from './Concepts.content';
import styles from './Concepts.module.sass';

const INTERVAL_MS = 4000;

const titleIndentClass = {
  0: styles['concepts__titleLine--i0'],
  1: styles['concepts__titleLine--i1'],
  2: styles['concepts__titleLine--i2'],
  3: styles['concepts__titleLine--i3'],
  4: styles['concepts__titleLine--i4'],
  5: styles['concepts__titleLine--i5'],
  6: styles['concepts__titleLine--i6'],
};

function TitleLine({ line }) {
  const indentClass = titleIndentClass[line.indent] ?? '';
  const baseClass = `${styles.concepts__titleLine} ${indentClass}`.trim();

  if (line.parts) {
    return (
      <span className={baseClass}>
        {line.parts.map((part, j) => (
          <span
            key={j}
            className={part.emphasis ? styles.concepts__titleLineEmphasis : undefined}
            style={{ opacity: part.opacity }}
          >
            {part.text}
          </span>
        ))}
      </span>
    );
  }

  return (
    <span className={baseClass} style={line.opacity != null ? { opacity: line.opacity } : undefined}>
      {line.text}
    </span>
  );
}

export function Concepts() {
  const [index, setIndex] = useState(0);
  const slides = conceptsContent.slides;
  const n = slides.length;

  const reduced =
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  useEffect(() => {
    if (reduced || n < 2) return undefined;
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % n);
    }, INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [n, reduced]);

  return (
    <section className={styles.concepts} aria-labelledby="concepts-heading">
      <div className={styles.concepts__inner}>
        <Container>
          <div className={styles.concepts__layout}>
            <h2 id="concepts-heading" className={styles.concepts__title}>
              {conceptsContent.headline.map((line, i) => (
                <TitleLine key={i} line={line} />
              ))}
            </h2>
            <p className={styles.concepts__center}>
              {conceptsContent.centerLines.map((line, i) => (
                <span
                  key={i}
                  className={styles.concepts__centerLine}
                  style={{ opacity: line.opacity }}
                >
                  {line.text}
                </span>
              ))}
            </p>
            <div
              className={styles.concepts__slider}
              aria-live={reduced ? undefined : 'polite'}
              aria-atomic="true"
            >
              {slides.map((slide, i) => (
                <div
                  key={i}
                  className={`${styles.concepts__slide} ${i === index ? styles.concepts__slideActive : ''}`}
                >
                  {slide.lines.map((line, j) => (
                    <span
                      key={j}
                      className={styles.concepts__slideLine}
                      style={{ opacity: line.opacity }}
                    >
                      {line.text}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}
